module.exports = __webpack_public_path__ + "img/knife-fork.278c7a2.svg";